export default {
  "pl": {
    "proposal": {
      "actions": {
        "addDescription": "Dodaj opis",
        "addDocuments": "Dodaj dokumenty",
        "addSubchoiceList": "Dodaj listę podwyborów",
        "addSubchoices": "Dodaj podopcje",
        "approve": "Zaakceptuj",
        "cancel": "Anuluj",
        "choice": {
          "collapse": "Zwiń listę wyborów",
          "delete": "Usuń wybór",
          "description": {
            "collapse": "Zwiń opisy",
            "expand": "Zwiń Rozwiń opisy opisów"
          },
          "edit": "Zmień wybór",
          "expand": "Rozwiń listę wyborów"
        },
        "choice_list": {
          "delete": "Usuń listę wyborów"
        },
        "deleteDescription": "Usuń opis",
        "deleteDocuments": "Usuń dokumenty",
        "delete_documents": "Usuń dokument | Usuń dokumenty",
        "delete_proposal": "Usuń ofertę",
        "delete_proposal_templates": "Usuń szablon propozycji",
        "duplicate": "duplikat",
        "edit": "Edytuj",
        "new": "Nowa oferta",
        "newProposalCustomer": "Nowa oferta",
        "publish": "Opublikuj",
        "reject": "Cofnij zatwierdzenie",
        "save": "Zapisz",
        "share": "Udostępnij",
        "shareWithProjectPartners": "Udostępniaj dokumenty partnerom projektu...",
        "share_units": "Udostępnij jednostkom",
        "signAndApprove": "Podpisz i zatwierdź ofertę",
        "signElectronically": "Możesz też złożyć podpis elektroniczny",
        "steps": {
          "collapse": "Zwiń listę kroków",
          "expand": "Rozwiń listę kroków"
        },
        "stop_template_sync": "Zatrzymaj synchronizację z szablonem",
        "submit": "Prześlij",
        "uploadAndApprove": "Prześlij i zatwierdź ofertę",
        "uploadSignableDocument": "Prześlij podpisany dokument do zatwierdzenia"
      },
      "attributes": {
        "amount_gross": "Oferta brutto",
        "amount_net": "Oferta netto",
        "choice_lists": {
          "description": "Opis",
          "name": "Nazwa"
        },
        "choices": {
          "description": "Opis",
          "images": "Obrazy",
          "name": "Nazwa",
          "price_gross": "Item price gross",
          "price_net": "Item price net",
          "quantity": "Liczba",
          "quantity_fixed": "Stała ilość",
          "quantity_max": "Maximum",
          "quantity_min": "Minimum",
          "quantity_not_fixed": "Pozwól klientowi uzupełnić ilość",
          "selected_default": "Zawsze wybrane"
        },
        "description": "Jak chcesz opisać tę ofertę?",
        "documents": "Dodaj dokumenty",
        "name": "Nazwa",
        "subtitle": "To ułatwi innym tworzenie odniesień",
        "title": "Nadaj tytuł swojej ofercie",
        "type": {
          "choices": "Pozwól, aby klient zdecydował",
          "fixed": "Oferta stała"
        },
        "vat_percentage": "VAT (%)"
      },
      "labels": {
        "accepted": "Zaakceptowano",
        "amount_net_total": "Oferta netto – suma",
        "amount_total": "Oferta brutto – suma",
        "approve": "Zatwierdź: {name}",
        "approved": "Zatwierdzono",
        "approvedDate": "Zatwierdzono dnia {date}",
        "ask_client_to_undo": "Nie możesz zmienić zatwierdzonej oferty. Najpierw skontaktuj się z klientem {client}, aby cofnąć zatwierdzenie.",
        "batchProposalsTemplate": "<p>Ta propozycja zostanie utworzona dla {units_count} jednostek.</p></br><p>Ponieważ ta propozycja zostanie utworzona dla wielu jednostek, stworzyliśmy z niej szablon. Szablony można znaleźć w zakładce „Propozycje”.</p></br><p>Szablony ułatwiają edytowanie lub usuwanie wszystkich propozycji opartych na tym szablonie.</p>",
        "batchProposalsWarning": "Ta oferta będzie dotyczyła następującej liczby jednostek: {units_count}. W razie potrzeby wprowadzenia zmian oferta dla każdej z jednostek będzie wymagała edycji z osobna.",
        "builder": {
          "can_select_multiple": "Możliwość wielokrotnego wyboru",
          "item": "Artykuł",
          "multiple_choices_possible": "Możliwość wielokrotnego wyboru",
          "must_choose_item": "Należy wybrać jedną z opcji",
          "options": "Wybory",
          "section": "Lista wyborów",
          "step": "Krok",
          "step_basic": "Informacje podstawowe",
          "step_details": "Szczegóły",
          "step_documents": "Dokumenty",
          "step_visibility": "Udostępnij:"
        },
        "by": "przez:",
        "choice_lists": {
          "add_another": "Dodaj kolejną listę wyborów",
          "create": "Utwórz listy wyborów związanych z ofertą",
          "empty_help": "Zacznij od dodania pierwszej listy wyborów (lub kilku list). Listy wyborów przedstawiają opcje z podziałem na konkretne artykuły, np. „płytki podłogowe”. Po dodaniu list wyborów możesz dodać do nich opcję (lup kilka opcji) do wyboru.",
          "selected": "Wybrano:"
        },
        "choices": {
          "add_another": "Dodaj kolejny wybór",
          "create": "Dodaj wybory do listy: {choiceListName}",
          "optional": "opcjonalnie",
          "selected_default": "Ten wybór będzie zawsze wybierany, a cena zostanie automatycznie obliczona w cenie całkowitej. Klient nie będzie mógł odznaczyć tego wyboru.",
          "subtotal": "Suma częściowa"
        },
        "closed": "Decyzja jest teraz zamknięta. Nie możesz już zatwierdzać propozycji.",
        "createProposal": "Utwórz ofertę",
        "createProposals": "Utwórz ofertę",
        "createdBy": "Utworzona przez użytkownika {uploader} dnia {date}",
        "customer": "Klient",
        "customerHasNotSelectedYet": "Klient nie dokonał jeszcze wyboru",
        "customer_name_confirm": "Aby zaakceptować tę ofertę, wpisz: <i><b>{customerName}</b></i>.",
        "customer_name_proceed": "Aby kontynuować, wpisz: <i><b>{customerName}</b></i>.",
        "customer_offer": "Oferta klienta",
        "customers": "Klienci",
        "delete_proposal_template": "<p>Jeśli usuniesz ten szablon, wszystkie zsynchronizowane propozycje również zostaną usunięte.<br>Jeśli nie chcesz, aby tak się stało, użyj przełącznika poniżej.</p>",
        "depends_on_customer_input": "Zależy od wkładu klienta",
        "documentsRequireSignature": "Klient musi podpisać dokumenty",
        "documents_shared_partners": "Tylko dokumenty wniosku są udostępniane partnerom projektu.",
        "duplicating": "powielanie",
        "editNotAllowed": "Usuwanie lub zmienianie zatwierdzonych ofert jest niedozwolone. Zanim dokonasz edycji, cofnij zatwierdzenie.",
        "editProposal": "Edytuj ofertę",
        "export_documents": "Eksportuj dokumenty",
        "full_prices": "Użyj pełnych cen. Ziggu automatycznie wygeneruje aktualizacje na podstawie budżetu decyzji",
        "internal_info": "Informacje do użytku wewnętrznego",
        "keep_synced_proposals": "Zachowaj zsynchronizowane propozycje, aby stały się samodzielnymi propozycjami.",
        "makeDecision": "Kliknij przycisk „Zatwierdź”, aby przyjąć ofertę dotyczącą: {decision_name}",
        "margin": "Marża",
        "new": "Utwórz nową ofertę",
        "noImage": "Brak obrazu",
        "no_budget_available_yet": "Nie dotyczy",
        "no_documents": "Oferta nie zawiera żadnych dokumentów.",
        "no_edit_details": "Ta propozycja zawiera elementy od niej zależne. Skontaktuj się z klientem, jeśli chcesz edytować szczegóły",
        "no_edit_details_installments": "Ta oferta obejmuje żądany lub opłacony termin raty. Aby edytować szczegóły, zmień powiązany okres raty na wersję roboczą statusu.",
        "no_edit_documents": "Po zatwierdzeniu oferty edycja dokumentów będzie niemożliwa.",
        "notApplicable": "nd.",
        "notSelectedYet": "Dokonaj wyborów, aby wyświetlić sumę",
        "notSharedYet": "Jeszcze nie udostępniono",
        "only_visible_team_partners": "Widoczna tylko dla zespołu i partnerów",
        "other": "Inne",
        "proposalFor": "Oferta dotycząca:",
        "proposal_template_sync_note": "Wprowadzanie zmian w szablonie oferty pakietowej aktualizuje wszystkie zsynchronizowane i niezatwierdzone oferty pakietowe.",
        "proposals": "Oferty",
        "proposalsApproved": "Zatwierdzone propozycje",
        "proposalsOther": "Inne propozycje",
        "reject_proposal_modal": {
          "body": "Podaj dodatkowe informacje, dlaczego odrzucasz tę propozycję",
          "title": "Odrzuć propozycję"
        },
        "requested_changes": "Odrzucony",
        "rejection_feedback": "Sprzężenie zwrotne",
        "relaunch": "Propozycja ponownego uruchomienia",
        "requiresSignature": "Musi podpisać dokumenty",
        "selectUnitsShare": "Wybierz jednostki, którym chcesz udostępnić szablon",
        "sharedWith": "Udostępniono:",
        "surcharges": "Opłaty dodatkowe",
        "synced_with_template": "Zsynchronizowane z szablonem propozycji",
        "synced_with_units": "Zsynchronizowany z 1 jednostką | Zsynchronizowano z {unit_count} jednostek",
        "template_accept_confirm": "<p>Ta propozycja jest oparta na szablonie propozycji. Kiedy zaakceptujesz tę propozycję, nie będzie ona już aktualizowana po zaktualizowaniu szablonu. W ten sposób synchronizacja zostanie zatrzymana.</p></br> <p>Czy na pewno chcesz zaakceptować tę propozycję?</p>",
        "template_edit_confirm": "<p>Ta propozycja jest oparta na szablonie propozycji. Kiedy edytujesz tę propozycję, nie będzie ona już aktualizowana po zaktualizowaniu szablonu. W ten sposób synchronizacja zostanie zatrzymana.</p></br> <p>Czy na pewno chcesz edytować tę propozycję?</p>",
        "total_excl_vat": "Razem bez VAT",
        "total_incl_vat": "łącznie z vat",
        "total_vat": "Całkowity podatek VAT",
        "typeToShare": "Rodzaj propozycji udostępnienia",
        "uploadDocuments": "Prześlij podpisane dokumenty",
        "uploadSignedDocument": "Możesz też przesłać podpisany dokument",
        "vat_excl": "bez VAT",
        "vat_excl_with_number": "bez VAT ({vat}%)",
        "writeEmployeeNameAccept": "Aby zaakceptować tę ofertę, wpisz: <i><b>{employeeName}</b></i>.",
        "writeEmployeeNameDelete": "Aby usunąć tę ofertę, wpisz: <i><b>{employeeName}</b></i>.",
        "writeEmployeeNameReject": "Aby cofnąć zatwierdzenie tej oferty, wpisz: <i><b>{employeeName}</b></i>."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Wkrótce znajdziesz tutaj ofertę do zatwierdzenia",
            "title": "Nie ma jeszcze ofert dotyczących decyzji: {decision_name}"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Złóż ofertę lub więcej ofert i pozwól klientowi zadecydować.",
            "title": "Utwórz ofertę"
          },
          "proposalNotice": "Ważne: zatwierdzić można tylko 1 ofertę. W razie potrzeby możesz zmienić istniejącą ofertę i dodać nowe dokumenty.",
          "template": {
            "subtitle": "Gdy tworzysz zbiorczo propozycje, pojawią się one tutaj",
            "title": "Nie utworzono jeszcze żadnych szablonów ofert."
          }
        },
        "partners": {
          "new": {
            "subtitle": "Złóż ofertę lub więcej ofert i pozwól klientowi zadecydować.",
            "title": "Utwórz ofertę"
          },
          "proposalNotice": "Ważne: zatwierdzić można tylko 1 ofertę. W razie potrzeby możesz zmienić istniejącą ofertę i dodać nowe dokumenty. Jeśli oferta została już zatwierdzona, członek zespołu może ją anulować przed dodaniem dodatkowych dokumentów."
        }
      },
      "toasts": {
        "create": "Utworzono ofertę",
        "delete": "Usunięto ofertę",
        "shareSuccess": "Propozycje pomyślnie udostępnione",
        "update": "Zaktualizowano ofertę"
      },
      "validation": {
        "amountNotUpdatable": "Nie można zaktualizować kwoty – niektóre raty są od niej zależne",
        "choice_list": {
          "needChoice": "Lista musi zawierać przynajmniej 1 wybór",
          "needSelection": "Ten wybór wymaga wybranego elementu"
        },
        "choices": {
          "lessThanOrEqual": "Liczba musi być mniejsza lub równa {max_number}",
          "needPriceItem": "Należy podać cenę za sztukę",
          "needSelection": "Należy podać opcję do wyboru",
          "needVatPercentage": "Procent VAT jest wymagany",
          "quantityBetween": "Ilość musi być pomiędzy {quantity_min} a {quantity_max}",
          "quantityNotZero": "Liczba musi wynosić przynajmniej 1",
          "quantityRequired": "Należy podać liczbę",
          "uniqueNames": "Nazwy nie mogą się powtarzać"
        },
        "nameNotCorrect": "Należy podać zgodną nazwę",
        "needName": "Należy podać tytuł",
        "needNumber": "Należy podać liczbę (np. 85)",
        "needRejectionNote": "Przekaż opinię, dlaczego odrzucasz tę propozycję",
        "readAllDocuments": "Pamiętaj, aby zapoznać się ze wszystkimi dokumentami",
        "requiresSignature": "Oznacz przynajmniej 1 dokument, na którym musi znaleźć się podpis elektroniczny klienta. Jeśli nie potrzebujesz podpisu, wyłącz opcję poniżej.",
        "share": {
          "needSelection": "Wybierz kogoś, komu chcesz udostępnić propozycję | Wybierz kogoś, komu chcesz udostępnić propozycje",
          "needType": "Wybierz typ(y) propozycji"
        },
        "uploadAtLeast1Document": "Prześlij przynajmniej 1 podpisany dokument"
      }
    }
  }
}
